export const nf = new Intl.NumberFormat('es-EC')
export const cf = new Intl.NumberFormat('es-EC', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 })

export const num = (v) => nf.format(v ?? 0)
export const money = (v) => cf.format(v ?? 0)
export const pct = (v) => `${((v ?? 0) * 100).toFixed(1)}%`

export function fecha(value) {
  if (!value) return '-'
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return '-'
  return d.toLocaleDateString('es-EC', { day: '2-digit', month: 'short', year: 'numeric' })
}

export function fechaHora(value) {
  if (!value) return '-'
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return '-'
  return d.toLocaleString('es-EC', { dateStyle: 'medium', timeStyle: 'short' })
}

export function dias(v) {
  if (v === null || v === undefined) return '-'
  if (v === 0) return 'hoy'
  return `${v} d`
}

/** Duracion legible: segundos por debajo de minuto y medio, si no minutos. */
export function duracion(segundos) {
  if (!segundos || segundos < 90) return `${Math.max(1, Math.round(segundos || 0))} s`
  const min = segundos / 60
  return `${min < 10 ? min.toFixed(1) : Math.round(min)} min`
}
